var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('slick-carousel',{key:_vm.carouselKey,ref:"slick",staticClass:"hotels-slider",attrs:{"options":_vm.slickOptions}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }